import { SupportAnalyticsPayload } from './types'
import client from '../../client'

export const sendSupportAnalytics = (payload: SupportAnalyticsPayload) =>
  client.post('/v1/support/analytics', payload)
